import { Caption1, makeStyles, tokens } from "@fluentui/react-components";
import { Warning16Filled } from "@fluentui/react-icons";
import type { Richiesta } from "../data/richieste";
import { formatDateTime } from "../lib/format";
import { InfoRow, Section } from "./Section";
import { StatoBadge } from "./StatoBadge";
import { PhotoGallery } from "./PhotoGallery";

const useStyles = makeStyles({
  head: { display: "flex", flexDirection: "column", gap: tokens.spacingVerticalXS },
  title: { margin: 0, fontSize: tokens.fontSizeBase500, fontWeight: tokens.fontWeightSemibold, lineHeight: tokens.lineHeightBase500 },
  line: { display: "flex", alignItems: "center", gap: tokens.spacingHorizontalS, flexWrap: "wrap" },
  urgente: { display: "inline-flex", alignItems: "center", gap: "4px", color: tokens.colorPaletteRedForeground1, fontWeight: tokens.fontWeightSemibold },
  muted: { color: tokens.colorNeutralForeground3 },
});

/** Parte in sola lettura di una richiesta: comune a richiedente e gestore. */
export function RichiestaInfo({ r, showStato = true }: { r: Richiesta; showStato?: boolean }) {
  const s = useStyles();
  const f = r.fields;
  return (
    <>
      <div className={s.head}>
        <h1 className={s.title}>{f.Title}</h1>
        <div className={s.line}>
          {showStato && <StatoBadge stato={f.Stato} size="large" />}
          {f.Priorita === "Urgente" && (
            <span className={s.urgente}>
              <Warning16Filled /> Urgente
            </span>
          )}
          <Caption1 className={s.muted}>
            #{r.id} · {formatDateTime(r.createdAt)}
          </Caption1>
        </div>
      </div>
      <Section>
        <InfoRow label="Richiedente">{r.createdBy?.displayName ?? "—"}</InfoRow>
        <InfoRow label="Sede">{f.Sede || f.Struttura || "—"}</InfoRow>
        <InfoRow label="Servizio">{f.Servizio ?? "—"}</InfoRow>
        {f.Area && <InfoRow label="Area">{f.Area}</InfoRow>}
        <InfoRow label="Categoria">{f.Categoria ?? "—"}</InfoRow>
        <InfoRow label="Descrizione">{f.Descrizione ?? "—"}</InfoRow>
      </Section>
      <Section title="Foto">
        <PhotoGallery richiestaId={r.id} />
      </Section>
    </>
  );
}
